module.exports = __webpack_public_path__ + "static/img/images_EL01.f767c2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/images_EL01.jpg
// module id = zh7x
// module chunks = 0